import React from 'react'
import PropTypes from 'prop-types'

import { colorMain1, colorMain2, colorError } from '../../lib/theme'

class Text extends React.Component {
  render() {

    const { children, style: s, hide, title, error, errorFormField, highlight, small, link, underline, ...otherProps } = this.props

    let style = {}

    // Defaults
    style.fontFamily = 'Open Sans, sans-serif'
    style.fontSize = 14

    // Error
    if (title) {
      style = { ...style,
        fontSize: 18,
        fontWeight: 'bold',
      }
    } else if (error) {
      style = { ...style,
        fontSize: 14,
        color: colorError
      }
    } else if (errorFormField) {
      style = { ...style,
        fontSize: 12,
        fontFamily: 'Roboto, sans-serif',
        color: colorError
      }
    } else if (highlight) {
      style = { ...style,
        fontSize: 16,
        color: 'white',
        backgroundColor: colorMain1,
        padding: '15px 25px',
        borderRadius: 50,
        display: 'inline-block',
        fontFamily: 'Roboto, sans-serif',
      }
    } else if (small) {
      style = { ...style,
        fontSize: 14,
        margin: 0,
        fontWeight: 'bold'
      }
    } else if (link) {
      style = { ...style,
        fontSize: 13,
        color: colorMain2,
        // fontWeight: 'bold',
        display: 'inline-block',
        textDecoration: 'underline',
        cursor: 'pointer'
      }
    }

    // Hide
    if (hide) {
      style.display = 'none'
    }
    if (underline) {
      style = { ...style,
        borderBottom: '2px solid',
        paddingBottom: 2,
        display: 'inline-block'
      }
    }

    // Now override with any incoming styles
    style = { ...style, ...s }

    return (
      <p style={style} {...otherProps}>{children}</p>
    )
  }
}
Text.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  hide: PropTypes.bool,
  title: PropTypes.bool,
  error: PropTypes.bool,
  errorFormField: PropTypes.bool,
  highlight: PropTypes.bool,
  small: PropTypes.bool,
  link: PropTypes.bool,
  underline: PropTypes.bool,
}
Text.defaultProps = {

}

export default Text



// WEBPACK FOOTER //
// ./src/components/Text2/index.js